export default "__VITE_PUBLIC_ASSET__f411a98a__"